/* RESPONSIBLE TEAM: team-inbox-experience */

const TYPE_ALIASES: Record<string, string> = {
  priority_level: 'priority',
};

// Normalizes frontend-only predicate type aliases to the canonical backend types
// before saving. The predicates addon uses `priority_level` to select the correct
// numericSelect editor, but the backend only knows `priority`.
export function normalizePredicateGroupTypes(predicateGroup: Record<string, unknown>): void {
  let predicates = predicateGroup.predicates as Record<string, unknown>[] | undefined;
  if (!predicates) {
    return;
  }
  normalizeOutbound(predicates);
}

function normalizeOutbound(predicates: Record<string, unknown>[]): void {
  for (let predicate of predicates) {
    let nested = predicate.predicates as Record<string, unknown>[] | undefined;
    if (nested) {
      normalizeOutbound(nested);
    } else {
      let alias = TYPE_ALIASES[predicate.type as string];
      if (alias) {
        predicate.type = alias;
      }
    }
  }
}

// Normalizes saved `priority` predicates back to `priority_level` on load so
// the predicates addon renders the numericSelect editor (not the boolean one).
// Only applies when the FF is on and the predicate has a numeric value
// (distinguishes multi-level predicates from legacy true/false ones).
export function normalizeRawPredicatesForLoad(
  predicates: Record<string, unknown>[],
  isPriorityLevelsEnabled: boolean,
): Record<string, unknown>[] {
  if (!isPriorityLevelsEnabled) {
    return predicates;
  }
  return predicates.map((predicate) => {
    let nested = predicate.predicates as Record<string, unknown>[] | undefined;
    if (nested) {
      return {
        ...predicate,
        predicates: normalizeRawPredicatesForLoad(nested, isPriorityLevelsEnabled),
      };
    }
    if (
      predicate.attribute === 'conversation.priority' &&
      predicate.type === 'priority' &&
      typeof predicate.value === 'number'
    ) {
      return { ...predicate, type: 'priority_level' };
    }
    return predicate;
  });
}
